import { FederatedModule } from "@bfme-technology/spa";
import { getResolvedMfeProps } from "../Dashboard.utils";



import type { CategoryBudgetsMfeProps } from './CategoryBudgetsMfe.types';

export const CategoryBudgetsMfe: React.FC<CategoryBudgetsMfeProps> = ({
  routesLoading,
  routes,
}) => {
  return (
    <section>
      {(() => {
        if (routesLoading) {
          return (
            <div className="text-text-muted text-xs py-10 text-center">
              Loading Budgets...
            </div>
          );
        }
        const route = routes.find((r) => r.key === "mfe-expense-manager");
        if (!route) {
          return (
            <div className="text-red-500 text-xs py-10 text-center">
              Expense Manager MFE configuration not found.
            </div>
          );
        }
        const resolved: any = getResolvedMfeProps(route);
        const { key, ...mfeProps } = resolved;

        return (
          <FederatedModule
            {...mfeProps}
            mfeType="federated"
            scope="mfe_expense_manager"
            module="./BudgetWidget"
            mfeProps={{ t: (_k: string, defaultText: string) => defaultText }}
          />
        );
      })()}
    </section>
  );
};
